import { Action } from '@ngrx/store';

export * from './actions';
export * from './effects';
export * from './reducers';

export const LOGOUT_ACTION = 'logout';
export function clearState(reducer) {
  return function(state, action) {
    if (action.type === LOGOUT_ACTION) {
      state = undefined;
    }

    return reducer(state, action);
  };
}
export class Logout implements Action {
  readonly type = LOGOUT_ACTION;
}
